(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wholebeans-box-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wholebeans-box-selector')) {
    customElements.define('wholebeans-box-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const form = this.querySelector('form');
        if (!form) return;
        this.initialized = true;
        this.form = form;
        this.requiredCount = Number(this.dataset.required);
        this.choices = Array.from(this.querySelectorAll('[data-choice]'));
        this.submitButton = this.querySelector('[data-submit]');
        this.status = this.querySelector('[data-status]');
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-choice]')) return;
          const selected = this.selected();
          const ids = new Set(selected.map(input => input.dataset.productId));
          if (selected.length > this.requiredCount || ids.size !== selected.length) event.target.checked = false;
          this.update();
        });
        this.querySelector('[data-search]').addEventListener('input', event => {
          const query = event.target.value.trim().toLocaleLowerCase();
          let visible = 0;
          this.querySelectorAll('[data-card]').forEach(card => {
            card.hidden = !card.dataset.searchName.toLocaleLowerCase().includes(query);
            if (!card.hidden) visible++;
          });
          this.querySelector('[data-empty]').hidden = visible > 0;
        });
        form.addEventListener('submit', event => {
          if (!this.isValid()) {
            event.preventDefault();
            this.status.textContent = this.dataset.error;
            this.querySelector('[data-search]').focus();
            return;
          }
          this.writeProperties();
          this.submitButton.disabled = true;
        });
        this.update();
      }
      selected() { return this.choices.filter(input => input.checked && input.dataset.stock === 'true'); }
      isValid() {
        const selected = this.selected();
        return selected.length === this.requiredCount && new Set(selected.map(input => input.dataset.productId)).size === this.requiredCount && this.dataset.available === 'true';
      }
      writeProperties() {
        const container = this.querySelector('[data-properties]');
        container.replaceChildren();
        const selected = this.selected();
        selected.forEach((choice, index) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${this.dataset.flavour} ${index + 1}]`;
          input.value = `${choice.dataset.name} — 40g`;
          container.append(input);
        });
        const component = document.createElement('input');
        component.type = 'hidden';
        component.name = 'properties[_wb_component_variants]';
        component.value = selected.map(input => input.value).join(',');
        container.append(component);
      }
      update() {
        const selected = this.selected();
        const remaining = this.requiredCount - selected.length;
        this.choices.forEach(input => {
          input.disabled = input.dataset.stock !== 'true' || (remaining === 0 && !input.checked);
        });
        this.querySelector('[data-count]').textContent = this.dataset.selected.replace('__COUNT__', selected.length);
        const pending = this.dataset.pending.replace('__COUNT__', remaining);
        this.status.textContent = remaining === 0 ? this.dataset.complete : pending;
        this.submitButton.textContent = this.dataset.available !== 'true' ? this.dataset.sold : remaining === 0 ? this.dataset.add : pending;
        this.submitButton.disabled = !this.isValid();
        const summary = this.querySelector('[data-selection]');
        summary.replaceChildren();
        selected.forEach(choice => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = `${choice.dataset.name} ×`;
          button.addEventListener('click', () => { choice.checked = false; this.update(); });
          summary.append(button);
        });
        this.writeProperties();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
